import { withOidcSecure } from '@axa-fr/react-oidc';
import { Route, Routes } from 'react-router-dom';

import { ApplicationRoutes, ApplicationBaseRoute } from 'modules/applications/Routes';
import { UserManagementBaseRoute, UserManagementRoutes } from 'modules/userManagement/Routes';
import { Home } from './Home';
import { NotFound } from './NotFound';
import { Unauthorized } from './Unauthorized';

const secureHome = withOidcSecure(Home);
const secureApplicationRoutes = withOidcSecure(ApplicationRoutes);
const secureUserManagementRoutes = withOidcSecure(UserManagementRoutes);

export const AppRoutes = () => {
    return (
        <Routes>
            <Route Component={secureHome} path="/" />
            <Route Component={secureApplicationRoutes} path={`/${ApplicationBaseRoute}/*`} />
            <Route Component={secureUserManagementRoutes} path={`/${UserManagementBaseRoute}/*`} />
            <Route Component={Unauthorized} path="/unauthorized" />
            <Route Component={NotFound} path="*" />
        </Routes>
    );
};
